var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.002 21v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2M8.998 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22.998 21v-2a4 4 0 0 0-3-3.87M16.002 3.13a4 4 0 0 1 0 7.75",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgGroup;